import { AvailableGlobalPermissions, AvailablePermissionsValue, RequiredPermissions } from 'features/validateAccess';

export const usersWidgetPermissions: RequiredPermissions = [
  [{ type: 'global', global: AvailableGlobalPermissions.ASSIGNMENT, value: AvailablePermissionsValue.READ }],
];
